// extracted by mini-css-extract-plugin
export var active = "_fo-7";
export var blink = "_fo-8";
export var dropDownSelector = "_fo-4";
export var dropDownWrapper = "_fo-3";
export var fakeCursor = "_fo-6";
export var fontSizeButton = "_fo-9";
export var formQuillEditor = "_fo-0";
export var pressed = "_fo-a";
export var qlBlank = "_fo-1";
export var textFormattingToolbar = "_fo-2";
export var textToolbarOption = "_fo-5";